import React, { useEffect } from 'react'
import Button from '../../../components/button/Button'
import { RECIPIENT_SECTION_LOADING_STATES, RECIPIENT_SECTION_MESSAGE_MAP, RECIPIENT_SECTION_ROUTES } from '../constants';
import styles from "./RecipientList.styles"
import Loadable from '../../../components/loadable/Loadable';
import Heading from '../../../components/heading/Heading';
import { HEADING } from '../../../components/heading/constants/constants';
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../../components/input/textinput/TextInput';
import Icons from '../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import CheckboxWLabel from '../../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import Pagination from '../../../components/richgrid/Pagination';
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants';
import { componentKey, setBulkAddressMatchModalOpen, setDeleteRecipientConfirmationModalOpen, setExportToExcelModal, setHighlightedRecipient, setPaginationState, setPayerDropdownPagination, setRecipientList, setRequestConsentModalOpen, setSelectedRecipients, setSingleActivateReactivateModal, toggleSelectedRecipient, setShouldReloadPaginatedRecipientList } from './RecipientListSlice';
import { bulkInactivate, bulkReactivate, deleteRecipient, getPaginatedRecipientsList } from './RecipientListSaga';
import { PAGE_STATE } from '../../constants/constants';
import RecipientCard from './recipientcard/RecipientCard';
import MultiSelectRecipientsActionCard from './multiselectrecipientsactioncard/MultiSelectRecipientsActionCard';
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup';
import { BUTTON_TYPE } from '../../../components/button/constants';
import RecipientInformation from './ricipientinformation/RecipientInformation';
import PayerDropdown from '../payerdropdown/PayerDropdown';
import Label from '../../../components/label/Label';
import { componentKey as recipientSectionKey, setPayersPaginationState, setSelectedPayer } from '../RecipientsSectionSlice';
import { getPaginatedPayersList } from '../RecipientsSectionSaga';
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator';
import CalendarInput from '../../../components/input/calendarinput/CalendarInput';
import { ACTIVE_INACTIVE_STATUS_OPTIONS, IS_TIN_REQUESTED_OPTIONS, RECIPIENT_LISTING_LOADING_STATES, RECIPIENT_LISTING_MESSAGE_MAP, TIN_STATUS_OPTIONS, VIEW_TIN_CHECKBOX_MESSAGE, W8_W9_STATUS_OPTIONS } from './constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import TinMatchModals from './tinmatchmodals/TinMatchModals';
import BulkW8RequestModals from './bulkw8requestmodals/BulkW8RequestModals';
import { getPrepaidAmount } from './tinmatchmodals/TinMatchSaga';
import BulkW9RequestModals from './bulkw9requestmodals/BulkW9RequestModals';
import BulkAddressMatch from './bulkaddressmatch/BulkAddressMatch';
import Popup from '../../../components/popup/Popup';
import ExportRecipientsDrawer from './exportrecipientsdrawer/ExportRecipientsDrawer';
import { componentKey as exportRecipientKey } from './exportrecipientsdrawer/ExportRecipientsDrawerSlice';
import { exportAllRecipients, exportSelectedRecipients } from './exportrecipientsdrawer/ExportRecipientsDrawerSaga';
import BulkActiveReactiveModals from './bulkactivereactivemodals/BulkActiveReactiveModals';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import { QUERY_PARAMS } from '../../formssection/constants';
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import { PermissionReroute, isAccessAllowed, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import RequestConsentModal from './requestconsentmodal/RequestConsentModal';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import { componentKey as authenticationComponentKey} from '../../authentication/AuthenticationSlice';
import { useState } from 'react';
import useDelayedAction from '../../../../libs/customhooks/useDelayedAction';

export default function RecipientList() {

    useGarbageCollector(componentKey);

    const navigate = useTxNavigate();
    const dispatch = useDispatch();
    const [hideTin, setHideTin] = useState(true);
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    const [queryParams, setQueryParams] = useTxSearchParams();
    
    const { loadingState, paginationState, recipientList, selectedRecipients, highlightedRecipient, deleteRecipientConfirmationModalOpen, bulkAddressMatchModalOpen, exportToExcelModal, requestConsentModalOpen, singleActivateReactivateModal, shouldReloadPaginatedRecipientList, payerDropdownPagination } = useSelector(state => state[componentKey]);

    const { payersList, payersPaginationState, selectedPayer, loadingState: recipientSectionLoader } = useSelector(state => state[recipientSectionKey]);

    const { selectedExportType, selectedForm } = useSelector(state => state[exportRecipientKey]);

    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])

    const { permissions } = useUserPermissionsInfo();

    useEffect(() => {
        PermissionReroute(PAGE_PERMISSIONS.VIEW_RECIPIENT, permissions, navigate, PAGE_PATH.DASHBOARD)
    }, [permissions])

    useEffect(() => {
        if (!payersList.length) {
            dispatch(getPaginatedPayersList({...payersPaginationState, selectedPayer}));
        }
    }, []);

    useEffect(() => {
        if (selectedPayer?.PayerDetailId) {
            dispatch(getPaginatedRecipientsList({...paginationState, PageNumber: 1, Skip: 0, selectedPayer, selectedRecipients, highlightedRecipient}))
        }else{
            dispatch(setRecipientList([]))
        }
    }, [selectedPayer])

    useEffect(() => {
        if(shouldReloadPaginatedRecipientList){
            dispatch(getPaginatedRecipientsList({...paginationState, selectedPayer, selectedRecipients, highlightedRecipient}))
            dispatch(setShouldReloadPaginatedRecipientList(false));
        }
    }, [shouldReloadPaginatedRecipientList])

    useEffect(() => {
        const urlPayerId = queryParams.get(QUERY_PARAMS.PAYER_ID)
        const urlRecipientName = queryParams.get(QUERY_PARAMS.RECIPIENT_NAME)
        const urlTaxId = queryParams.get(QUERY_PARAMS.RECIPIENT_ID)
        const urlemailId = queryParams.get(QUERY_PARAMS.RECIPIENT_EMAIL)
        const urlTINStatus = queryParams.get(QUERY_PARAMS.TIN_STATUS)
        const urlIsActive = queryParams.get(QUERY_PARAMS.IS_ACTIVE)
        const urlW8W9Status = queryParams.get(QUERY_PARAMS.W8_W9_STATUS)
        const urlIsTinRequested = queryParams.get(QUERY_PARAMS.IS_TIN_REQUESTED)
        const urlFrom = queryParams.get(QUERY_PARAMS.FROM)
        const urlTo = queryParams.get(QUERY_PARAMS.TO)

        const TINStatus = TIN_STATUS_OPTIONS.find(elm => elm.label === urlTINStatus)
        const isActive = ACTIVE_INACTIVE_STATUS_OPTIONS.find(elm => elm.label === urlIsActive)
        const W8W9Status = W8_W9_STATUS_OPTIONS.find(elm => elm.key === urlW8W9Status)
        const isTinRequested = IS_TIN_REQUESTED_OPTIONS.find(elm => elm.key === urlIsTinRequested)

        if (urlPayerId) {
            dispatch(getPaginatedPayersList({ ...payersPaginationState, PayerDetailId: urlPayerId, selectedPayer }));
            queryParams.set(QUERY_PARAMS.PAYER_ID, urlPayerId)
            setQueryParams(queryParams)
        }

        dispatch(setPaginationState({ FilterText: urlRecipientName || "", IdNumber: urlTaxId || "", emailid: urlemailId || "", TINStatus: TINStatus || "", IsActive: isActive || { label: "", value: "" }, W8W9Status: W8W9Status || W8W9Status, IsTinRequested: isTinRequested || { label: "", value: "" }, TinStartDate: urlFrom || "", TinEndDate: urlTo || "" }))
    }, [])

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])

    const onChangeFilterHandler = (e) => {
        const { name, value } = e.target;
        dispatch(setPaginationState({ [name]: value }))
    };

    const recipientDateFilterHandler = () => {
        if (!paginationState.TinStartDate || !paginationState.TinEndDate) {
            dispatch(addNotifications({ heading: "Error", message: "Please select start and end date" }))
        } else {
            dispatch(getPaginatedRecipientsList({ ...paginationState, PageNumber: 1, Skip: 0, TinStartDate: paginationState.TinStartDate, TinEndDate: paginationState?.TinEndDate, selectedPayer, selectedRecipients, highlightedRecipient }))

            if (paginationState.TinStartDate && paginationState.TinEndDate) {
                queryParams.set(QUERY_PARAMS.FROM, paginationState.TinStartDate)
                queryParams.set(QUERY_PARAMS.TO, paginationState.TinEndDate)

                setQueryParams(queryParams)
            }
        }
    }

    const handleFilterInputSearch = (inputFieldName, e = null) => {
        if(e === null || e.key === "Enter"){
            dispatch(getPaginatedRecipientsList({...paginationState, PageNumber: 1, Skip: 0, selectedPayer, selectedRecipients, highlightedRecipient}))
            if (paginationState[inputFieldName]) {
                queryParams.set(QUERY_PARAMS[inputFieldName], paginationState[inputFieldName])
            } else {
                queryParams.delete(QUERY_PARAMS[inputFieldName])
            }

            setQueryParams(queryParams)
        }
    }

    const onChangeFilterDropdownHandler = (name, selectedOption) => {
        dispatch(setPaginationState({ [name]: selectedOption }))

        if (name === "W8W9Status") {

            const w8w9requestPrams = {
                IsW8request: "",
                IsW9Request: "",
            }

            switch (selectedOption.value) {
                case "IsW8request":
                    w8w9requestPrams.IsW8request = false;
                    break;

                case "IsW9Request":
                    w8w9requestPrams.IsW9Request = false;
                    break;

                case "W8Completed":
                    w8w9requestPrams.IsW8request = true;
                    break;

                case "W9Completed":
                    w8w9requestPrams.IsW9Request = true;
                    break;

                case "None":
                    w8w9requestPrams.IsW8request = '';
                    w8w9requestPrams.IsW9Request = '';
                    break;
            }

            dispatch(getPaginatedRecipientsList({ ...paginationState, PageNumber: 1, Skip: 0, [name]: selectedOption, ...w8w9requestPrams, selectedPayer, selectedRecipients, highlightedRecipient }))

        } else {
            dispatch(getPaginatedRecipientsList({ ...paginationState, PageNumber: 1, Skip: 0, [name]: selectedOption, selectedPayer, selectedRecipients, highlightedRecipient }))
        }

        if (selectedOption?.key || selectedOption.label) {
            queryParams.set(name, (selectedOption?.key || selectedOption.label))
        } else {
            queryParams.delete(name)
        }

        setQueryParams(queryParams)
    }

    const { FETCHING_RECIPIENT_LIST_LOADING, DELETE_RECIPIENT_LOADING } = RECIPIENT_LISTING_LOADING_STATES;

    return (
        <>
            <Loadable
                currentState={recipientSectionLoader.state}
                loadingStates={[RECIPIENT_SECTION_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                messageMap={RECIPIENT_SECTION_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <div style={styles.headerContainer}>

                    <div style={styles.titleAndSearch}>
                        <Heading type={HEADING.H1}>Recipient listing</Heading>

                        {/* Payer Selection Section */}
                        <div style={styles.selectPayerContainer}>
                            <PayerDropdown
                                options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                                hideHeader={true}
                                containerStyles={styles.payerdropdownContainer}
                                dropdownContainerStyles={styles.payerdropdown}
                                selectPayerDropdownProps={{
                                    selectedValue: selectedPayer,
                                    styles: styles.payerSearchInput,
                                    // This functions will be used when we have the paginated list for payers, currently we are fetching the full list of payers
                                    onSearchInputChangeCb: (searchText, filterOption) => {
                                        const filteredOptions = payersList.filter(opt => opt[filterOption?.value == "NAME" ? "Name" : "IdNumber"].toLowerCase().includes(searchText.toLowerCase()))
                                        setPaginatedPayerList(filteredOptions)
                                        dispatch(setPayerDropdownPagination({ PageNumber: 1 }))
                                    //     dispatch(getPaginatedPayersList({ ...payersPaginationState, PageNumber: 1, ...(filterOption.value == "NAME" ? { FilterText: searchText } : { IdNumber: searchText }) }))
                                    },
                                    onDropdownTouchedToBottomCb: () => {
                                        if(payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length){   
                                            dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                        }
                                        // dispatch(getPaginatedPayersList({ ...payersPaginationState, PageNumber: payersPaginationState.PageNumber + 1 }))
                                    },
                                    clearSearchTextCb: () => {
                                        setPaginatedPayerList(payersList)
                                        // dispatch(setPayersPaginationState({ ...payersPaginationState, FilterText: "", IdNumber: "" }))
                                    },
                                    onSelectCb: (name, selectedOption) => {
                                        dispatch(setSelectedRecipients([]))
                                        dispatch(setSelectedPayer(selectedOption))
                                        if (selectedOption.value) {
                                            queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.PayerDetailId)
                                        } else {
                                            queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                        }
                                        setQueryParams(queryParams)
                                    }
                                }}
                            />
                        </div>


                        <div style={styles.buttonContainer}>
                            <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_RECIPIENT}>
                                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} prefixProps={{ icon: VEC_ICON_NAME.ADD_PAYER_ICON }} onClickCb={() => navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}/${RECIPIENT_SECTION_ROUTES.ADD}`)}>Add Recipient</Button>
                            </ShowForAllowedPermissionsOnly>
                            <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={styles.button} prefixProps={{ icon: VEC_ICON_NAME.COPY_ICON }} onClickCb={() => navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}/${RECIPIENT_SECTION_ROUTES.MOVE_RECIPIENTS}`)}>Copy Recipient</Button>
                        </div>

                    </div>

                    <HorizontalSeparator />

                    {/* Recipient Filters Section */}
                    <div style={styles.calendarBox}>
                        <div style={styles.filtersContainer}>

                            <TextInput
                                name="FilterText"
                                label='Search by Name'
                                placeHolder='Enter recipient name'
                                suffixProps={{
                                    icon: VEC_ICON_NAME.SEARCH_ICON,
                                    suffixIconCb: () => handleFilterInputSearch("FilterText")
                                }}
                                value={paginationState.FilterText}
                                onChangeCb={onChangeFilterHandler}
                                onKeyDownCb={(e) => handleFilterInputSearch("FilterText", e)}
                            />

                            <TextInput
                                name="IdNumber"
                                label='Search by Tax ID'
                                placeHolder='Enter tax id'
                                suffixProps={{
                                    icon: VEC_ICON_NAME.SEARCH_ICON,
                                    suffixIconCb: () => handleFilterInputSearch("RECIPIENT_ID")
                                }}
                                value={paginationState.IdNumber}
                                onChangeCb={onChangeFilterHandler}
                                onKeyDownCb={(e) => handleFilterInputSearch("RECIPIENT_ID", e)}
                            />

                            <TextInput
                                name="emailid"
                                label='Search by Email'
                                placeHolder='Enter email address'
                                suffixProps={{
                                    icon: VEC_ICON_NAME.SEARCH_ICON,
                                    suffixIconCb: () => handleFilterInputSearch("RECIPIENT_EMAIL")
                                }}
                                value={paginationState.emailid}
                                onChangeCb={onChangeFilterHandler}
                                onKeyDownCb={(e) => handleFilterInputSearch("RECIPIENT_EMAIL", e)}
                            />

                            <div style={styles.selectDropdown}>
                                <SelectDropdown
                                    name="TINStatus"
                                    label="Search by TIN Status"
                                    placeHolder="Select tin status"
                                    value={paginationState.TINStatus}
                                    onSelectCb={onChangeFilterDropdownHandler}
                                    options={TIN_STATUS_OPTIONS}
                                />
                            </div>

                            <div style={styles.selectDropdown}>
                                <SelectDropdown
                                    name="IsActive"
                                    label="Recipient Status"
                                    placeHolder="Please select status"
                                    value={paginationState.IsActive}
                                    onSelectCb={onChangeFilterDropdownHandler}
                                    options={ACTIVE_INACTIVE_STATUS_OPTIONS}
                                />
                            </div>

                            <div style={styles.selectDropdown}>
                                <SelectDropdown
                                    name="W8W9Status"
                                    label="W8/W9 Status"
                                    value={paginationState.W8W9Status}
                                    placeHolder="W8/W9 Status"
                                    onSelectCb={onChangeFilterDropdownHandler}
                                    options={W8_W9_STATUS_OPTIONS}
                                />
                            </div>

                            <div style={styles.selectDropdown}>
                                <SelectDropdown
                                    name="IsTinRequested"
                                    label="TIN Status"
                                    placeHolder="Please select TIN"
                                    value={paginationState.IsTinRequested}
                                    onSelectCb={onChangeFilterDropdownHandler}
                                    options={IS_TIN_REQUESTED_OPTIONS}
                                />
                            </div>

                            <div style={styles.calendarBox}>
                                <CalendarInput
                                    name="TinStartDate"
                                    label={'FROM'}
                                    value={paginationState?.TinStartDate}
                                    onChangeCb={onChangeFilterHandler}
                                />

                                <CalendarInput
                                    name="TinEndDate"
                                    label={'TO'}
                                    value={paginationState?.TinEndDate}
                                    onChangeCb={onChangeFilterHandler}
                                />

                                <div style={styles.calendarButtonsContainer}>
                                    <Button onClickCb={recipientDateFilterHandler} style={styles.calendarButton} type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}>
                                        Apply
                                    </Button>

                                    <Button onClickCb={() => {
                                        if (paginationState.TinStartDate || paginationState.TinEndDate) {
                                            dispatch(getPaginatedRecipientsList({ ...paginationState, PageNumber: 1, Skip: 0, TinStartDate: "", TinEndDate: "",  selectedPayer, selectedRecipients, highlightedRecipient }))

                                            queryParams.delete(QUERY_PARAMS.FROM)
                                            queryParams.delete(QUERY_PARAMS.TO)
                                            setQueryParams(queryParams)
                                        }
                                    }}
                                        style={styles.calendarButton}
                                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}>
                                        Clear
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>


                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[FETCHING_RECIPIENT_LIST_LOADING, DELETE_RECIPIENT_LOADING]}
                        messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        {recipientList.length ?
                            <>
                                <div style={styles.selectAllBox}>
                                    <CheckboxWLabel iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON} checked={selectedRecipients?.length} label={selectedRecipients?.length ? "Unselect All" : "Select All on Current Page"} onChangeCb={(event) => dispatch(setSelectedRecipients(selectedRecipients?.length ? [] : recipientList))} name="selectAll" />

                                    <div style={styles.leftLiftOptionsRow}>
                                        {
                                            signedInUser.IsTinUnmaskAllowed ? <CheckboxWLabel
                                                label={<span title={VIEW_TIN_CHECKBOX_MESSAGE} className='fs-16'>View TIN <span><Icons familyName={"vec"} iconName={VEC_ICON_NAME.INFO_ICON} /></span></span>}
                                                checked={!hideTin}
                                                onChangeCb={() => setHideTin(!hideTin)}
                                            /> : null
                                        }
                                        <div onClick={() => dispatch(getPaginatedRecipientsList({ ...paginationState, PageNumber: 1, Skip: 0, IsDesc: !paginationState?.IsDesc, selectedPayer, selectedRecipients, highlightedRecipient }))}>
                                            <Icons familyName='vec' iconName={VEC_ICON_NAME.SORT_ICON} rotateDeg={paginationState?.IsDesc ? 0 : 180} />
                                        </div>
                                    </div>
                                </div>

                                <div style={styles.recipientListContainer}>

                                    <div style={styles.cardContainer}>
                                        <div>
                                            {recipientList.map((recipient, idx) => (

                                                <RecipientCard
                                                    key={`recipient-card-${idx}`}
                                                    onChangeCheckboxCb={(e) => dispatch(toggleSelectedRecipient({ recipient, selectedRecipients, isChecked: e.target.checked }))}
                                                    isSelected={selectedRecipients.find(selectedRow => selectedRow.RecipentDetailId == recipient?.RecipentDetailId)}
                                                    recipient={recipient}
                                                    hideTin={hideTin}
                                                    isHighlighted={recipient?.RecipentDetailId === highlightedRecipient?.RecipentDetailId}
                                                    onCardClickCb={() => dispatch(setHighlightedRecipient(recipient))}
                                                />
                                            ))}
                                        </div>

                                        <div>
                                            <Pagination
                                                skip={paginationState?.Skip}
                                                take={paginationState?.PageSize}
                                                takeOptions={ROW_SELECTION_OPTIONS}
                                                onChangeTakeCb={(newTake) => {
                                                    dispatch(setPaginationState({...paginationState, PageSize: newTake}))
                                                    dispatch(getPaginatedRecipientsList({ ...paginationState, PageSize: newTake, Skip: 0, PageNumber: 1, selectedPayer, selectedRecipients, highlightedRecipient }))
                                                }}
                                                total={paginationState?.totalRecipients}
                                                onChange={(take, t) => {
                                                    dispatch(setPaginationState({...paginationState, PageSize: take, Skip: t}))
                                                    dispatch(getPaginatedRecipientsList({ ...paginationState, PageSize: take, Skip: t, PageNumber: Math.ceil((take + t) / take), selectedPayer, selectedRecipients, highlightedRecipient }))
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div style={styles.recipientInformationContainer}>
                                        {
                                            selectedRecipients.length ? <MultiSelectRecipientsActionCard /> : <RecipientInformation hideTin={hideTin} />
                                        }
                                    </div>

                                </div>
                            </>

                            :

                            <div style={styles.noRecipientsFoundContainer}>
                                <Heading type={HEADING.H2}>No Recipients Found</Heading>
                            </div>
                        }
                    </Loadable>

                </div>

                <Loadable
                    currentState={loadingState?.state}
                    loadingStates={[RECIPIENT_LISTING_LOADING_STATES.DELETE_RECIPIENT_LOADING]}
                    messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
                    preserveChildMount={true}
                    isNewLoadable={true}
                >
                    {/* Delete Confirmation Modal */}
                    <ConfirmationPopup
                        title='Are you sure?'
                        bodyText='Do you want to delete all recipients under the selected payer or delete only the selected recipients?'
                        iconName={VEC_ICON_NAME.WARNING_ICON}
                        isOpen={deleteRecipientConfirmationModalOpen}
                        confirmationButtonProps={
                            {
                                onConfirmationCb: () => {
                                    dispatch(deleteRecipient({ highlightedRecipient, selectedRecipients, selectedPayer, isAllSelect: true }))
                                },
                                confirmationButtonText: "Delete All Recipients",
                                confirmationButtonStyles: {},
                                confirmationButtonType: BUTTON_TYPE.PRIMARY,
                            }
                        }
                        cancelButtonProps={{
                            onCancelCb: () => {
                                dispatch(deleteRecipient({ highlightedRecipient, selectedRecipients, selectedPayer, isAllSelect: false }))
                            },
                            onCloseCb: () => {
                                dispatch(setDeleteRecipientConfirmationModalOpen(false))
                            },
                            cancelButtonText: "Delete Selected Recipients",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        }}
                        isClose={false}
                        customStyle={styles.tinMatchPopup}
                    />
                </Loadable>

                {/* Request Tin Match Modals */}
                <TinMatchModals />

                {/* Bulk W8 Request Modals */}
                <BulkW8RequestModals />

                {/* Bulk W9 Request Modals */}
                <BulkW9RequestModals />

                {/* Bulk Activate/Reactivate Modals */}
                <BulkActiveReactiveModals />

                <Loadable
                    currentState={loadingState?.state}
                    loadingStates={[RECIPIENT_LISTING_LOADING_STATES.BULK_INACTIVATE_LOADING, RECIPIENT_LISTING_LOADING_STATES.BULK_REACTIVATE_LOADING]}
                    messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
                    preserveChildMount={true}
                    isNewLoadable={true}
                >
                    {/* Single Activate/Reactivate Recipient */}
                    {singleActivateReactivateModal && <ConfirmationPopup
                        isOpen={singleActivateReactivateModal}
                        title={highlightedRecipient?.ISActive ? "De-Activate Recipient" : "Activate Recipient"}
                        bodyText={`Are you sure you want to ${highlightedRecipient?.ISActive ? "de-activate" : "activate"} the selected recipient?`}
                        confirmationButtonProps={
                            {
                                onConfirmationCb: () => {
                                    const data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: [highlightedRecipient?.RecipentDetailId], selectAll: false }
                                    highlightedRecipient?.ISActive ? dispatch(bulkInactivate(data)) : dispatch(bulkReactivate(data))
                                },
                                confirmationButtonText: highlightedRecipient?.ISActive ? "De-Activate" : "Activate",
                                confirmationButtonStyles: {},
                                confirmationButtonType: BUTTON_TYPE.PRIMARY,
                            }
                        }
                        cancelButtonProps={
                            {
                                onCancelCb: () => dispatch(setSingleActivateReactivateModal(false)),
                                cancelButtonText: "Cancel",
                                cancelButtonStyles: {},
                                cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                            }
                        }
                    />}
                </Loadable>

                {requestConsentModalOpen && <RequestConsentModal
                    isOpen={requestConsentModalOpen}
                    onCloseCb={() => dispatch(setRequestConsentModalOpen(false))}
                    selectedPayer={selectedPayer}
                    selectedRecipients={selectedRecipients}
                    highlightedRecipient={highlightedRecipient}
                    onPaymentSuccessCb={() => {
                        dispatch(getPaginatedRecipientsList({...paginationState, selectedPayer, selectedRecipients, highlightedRecipient}));
                        dispatch(addNotifications({ heading: "Success", message: "Consent request successful", variant: TOASTER_VARIANT.SUCCESS }))
                        dispatch(setRequestConsentModalOpen(false));
                    }}
                />}

                {/* Bulk Address Match Modal */}
                {bulkAddressMatchModalOpen && <Popup
                    isPopupOpen={bulkAddressMatchModalOpen}
                    title={"USPS Bulk Address Validation"}
                    onCloseCb={() => dispatch(setBulkAddressMatchModalOpen(false))}
                    children={<BulkAddressMatch />}
                    customPopupSyles={styles.bulkAddressMatchPopup}
                />}

                {/* Export To Excel Drawer */}
                {exportToExcelModal && <ExportRecipientsDrawer
                    isOpen={exportToExcelModal}
                    onCloseCb={() => dispatch(setExportToExcelModal(false))}
                    backButtonProp={{
                        backCb: () => dispatch(setExportToExcelModal(false)),
                        text: "Close",
                    }}
                    submitButtonProp={{
                        submitCb: () => {
                            if (selectedExportType == "ALL") {
                                dispatch(exportAllRecipients(selectedForm))
                            } else {
                                dispatch(exportSelectedRecipients({ selectedForm, selectedPayer, selectedRecipients }))
                            }
                        },
                        text: "Export",
                    }}
                />}

            </Loadable>
        </>
    )
}